import { createClient } from './supabase/client';

export const supabase = createClient();
